import { apiCallAdmin } from "./api-service";

export const getOrgLogoApi = async () => {
  try {
    const response = await apiCallAdmin("get", "get_org_image");
    return response?.data;
  } catch (err) {
    console.error("Error fetching org logo:", err);
  }
};
